import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IAddRTMTimeLogNewReq, IAddRTMTimeLogRes } from './index.type';

const useAddRTMTimeLog = ({ RtmTimeLogId }: { RtmTimeLogId?: string }) => {
  const url = RtmTimeLogId 
    ? `/RTM/updateTimeLog/${RtmTimeLogId}` 
    : `/RTM/addTimeLog`;
    
  const method = RtmTimeLogId ? 'PUT' : 'POST';
  const { loading: addRTMTimeLogLoading, makeApiCall } = useApi({ url, method });
  
  const addRTMTimeLog = async (formData: IAddRTMTimeLogNewReq) => {
    const apiRequestData = {
      clinicianId: "61a8de7a7e15514c8b873a46", 
      patientId: "61a8de7a7e15514c8b873a44", 
      description: formData.description,  
      duration: formData.duration === 'Custom' ? 
        parseInt(formData.customDuration) : 
        parseInt(formData.duration)
    };
    
    const { response, error } = await makeApiCall<typeof apiRequestData, IAddRTMTimeLogRes>(apiRequestData);
    
    if (response?.status === 'success') {
      toast.success(RtmTimeLogId ? 'Time log updated successfully' : 'Time log added successfully');
      return response;
    }
    
    if (error || !response?.status) {
      toast.error(error?.msg || 'Failed to save time log. Please check the data and try again.');
      return { status: 'fail' };
    }
  };
  
  return {
    addRTMTimeLogLoading,
    addRTMTimeLog,
  };
};

export default useAddRTMTimeLog;